export default __webpack_public_path__ + "static/media/avatar_tommy7.aa924505.mp3";